module.exports = __webpack_public_path__ + "static/media/orthodoxZikaronBasalonWelcome.cf5f7beb.svg";